import $ from 'jquery';
window.$ = window.jQuery = $;
import AOS from 'aos';
import gsap from 'gsap';
import "jquery-match-height/jquery.matchHeight";
// import("./vendors/carbon");
require('./vendors/inview');
// import './customCursor';
require('./vendors/jquery-menu-aim')
require('./vendors/countUp.min')
require('./vendors/Chart.min')
/****************************************************************************
 * Theme scripts.
 ****************************************************************************/

import {sliders} from './sliders';
import {stickyNav} from './stickyNav';
import {numberAnimation} from './numberAnimation';
import {searchHighlight} from './searchHighlight';
import {hamburgerMenu} from './hamburgerMenu';
import {videoPlayer} from './videoPlayer';
import {menuAim} from './menuAim';
import {teamAcc} from './teamAcc';

window.addEventListener('load', function() {
    AOS.refresh();
});

function counter(){
    $('.stats-block__outer.aos-animate .js-number').each(function() {
        var $this = $(this),
            countTo = $this.attr('data-number');

        $({ countNum: $this.text()}).animate({
                countNum: countTo
            },

            {
                duration: 1000,
                easing:'linear',
                step: function() {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function() {
                    $this.text(this.countNum);
                    //alert('finished');
                }

            });

    });
}

function pieCharts() {

    $(function() {
        $('.chart-wrapper.aos-animate .chart').easyPieChart({
            size: 231,
            barColor: "#273B43",
            scaleLength: 0,
            lineWidth: 2,
            trackColor: "#FFFFFF",
            lineCap: "circle",
            animate: 2000,
        });
    });
}

(function( $ ){
    'use strict';

    setTimeout( () => {

        AOS.init({  duration: 1000 });
        sliders.init();
        // numberAnimation.init();
        hamburgerMenu.init();
        stickyNav.init();
        searchHighlight.init();
        videoPlayer.init();
        menuAim.init();
        teamAcc.init();

        if($('.program-block__content p')[0]){
            $('.program-block__content p').matchHeight();
        }

        $('.search button').on('click', function(){
            $('.search__form-wrapper').toggleClass('search-open');
            $('.search-trigger').hide();
        })

        $('.search-fire').on('click', function(){
            $('#searchform').submit();
        });

        $( "body" ).on('click', ".facetwp-checkbox",  function(){
            $('.select-all').addClass('remove-checked');
            console.log('clicked');
        });

        $( "body" ).on('click', ".select-all",  function(){
           setTimeout(function(){
               $('.select-all').removeClass('remove-checked');
               $('.facetwp-checkbox').addClass('checked');
           }, 800)
        });

        $("body").on('click', ".facetwp-reset", function(){
            setTimeout(function(){
                $('.select-all').addClass('checked').removeClass('remove-checked');
            }, 1000)
        })


    }, 400 );

    setTimeout( () => {

        // scroll.update();

    }, 2000 );

    $(window).on('scroll', function (event) {
        AOS.refresh();
        counter();
        pieCharts();
    });


} )( jQuery );

$(function(){



})

/***************
 * After theme scripts
 ***************/
// // Each time the window updates, refresh ScrollTrigger and then update LocomotiveScroll
// ScrollTrigger.addEventListener( 'refresh', () => scroll.update() );
//
// // After everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
// ScrollTrigger.refresh();